import { IView } from "@formant/core/model/IView";

import { authStore } from "../stores";

export function isViewLiveConfigurable(view: IView): boolean {
    return (
        (view.url !== undefined && view.url !== null) ||
        view.layoutType === "fullscreen" ||
        view.layoutType === "dashboard" ||
        view.layoutType === "analytics" ||
        (view.layoutType === "teleop" && !authStore.featureEnabled("teleop2.0"))
    );
}
